import { Modal } from "antd";
import { ExitSoftware } from "../sessionManager";
export default async function getLocation() {
  console.log("location", navigator.geolocation);
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(showPosition, showError);
  } else {
    Modal.error({
      title: "خطای نقطه مکانی",
      content: "مرورگر شما از سامانه ما پشتیبانی نمیکند",
    });
    localStorage.removeItem("location");
    ExitSoftware();
  }
}

function showPosition(position) {
  navigator.geolocation.getCurrentPosition((position) => {
    localStorage.setItem("loaction", {
      lat: position.coords.latitude,
      long: position.coords.longitude,
    });
  });
}

function showError(error) {
  switch (error.code) {
    case error.PERMISSION_DENIED:
      Modal.error({
        title: "خطای نقطه مکانی",
        content: "دسترسی به نقطه مکانی الزامی میباشد",
      });
      break;
    case error.POSITION_UNAVAILABLE:
      Modal.error({
        title: "خطای نقطه مکانی",
        content: "عدم ارتباط با اینترنت",
      });
      break;
    case error.TIMEOUT:
      Modal.error({
        title: "خطای نقطه مکانی",
        content: "پاسخی از سرور دریافت نشد لطفا اینترنت خود را برسی کنید",
      });
      break;
    case error.UNKNOWN_ERROR:
      Modal.error({
        title: "خطای نقطه مکانی",
        content: "مشکلی هنگام انجام عملیات رخ داد.",
      });
      break;
    default:
      break;
  }
  // localStorage.removeItem("location");
  // ExitSoftware();
}

export function giveLocation() {
    // let result={}
    let r={}
  if (navigator.geolocation) {
     navigator.geolocation.getCurrentPosition(
        (position) => {
          // result.status= true;
          // result.latitude= position.coords.latitude;
          // result.longitude= position.coords.longitude;
          r={
            status: true,
            latitude: position.coords.latitude,
            longitude: position.coords.longitude
          }
        },
        (err) => {
          r={
            status: false,
            message: err.message
          }
          
          // result.status= false; 
          // result.message= err.message
          return r;
        }
      );
  } else {
    r={
      status: false,
      message: "دسترسی به موقعیت مکانی وجود ندارد"
    }
    // result.status= false; 
    // result.message= "دسترسی به موقعیت مکانی وجود ندارد";
    return r;
  }
  return(r)
}

export function CalcDistance (coords1, coords2) {
  const toRad = (value) => (value * Math.PI) / 180;
  
  const lat1 = coords1.latitude;
  const lon1 = coords1.longitude;
  const lat2 = coords2.latitude;
  const lon2 = coords2.longitude;

  const R = 6371000; // Radius of the Earth in meters

  const dLat = toRad(lat2 - lat1);
  const dLon = toRad(lon2 - lon1);

  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
    Math.sin(dLon / 2) * Math.sin(dLon / 2);

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  const distance = R * c; // Distance in meters
  return distance;
};



